export class FailureDetail {

    constructor(data) {
        this.code = data && data.code ? data.code : "";
        this.message = data && data.message ? data.message : "";
        this.type = data && data.type ? data.type : "";
    }
}